import React, { useEffect, useState, useRef } from "react";
import { Modal, Nav, Button, Row, Col, Container } from "react-bootstrap";
import FavoriteButton from '../assets/images/heart.svg';
import ShareButton from '../assets/images/share.svg';
import StreetView from "./StreetView";
import RequestTourModal from './RequestTourModal';
import ConfirmTourModal from './ConfirmTourModal';
import ContactAgentModal from "./ContactAgentModal";
import { useNavigate } from "react-router-dom";
import useFavorites from "../hooks/useFavorites";

function AllPhotoModal({ show, handleClose, property }) {

  const navigate = useNavigate();
  const [activeAllPhotoTab, setActiveAllPhotoTab] = useState("photos");
  const [activePhotoGalleryTab, setActivePhotoGalleryTab] = useState("all-photos");
  const { isFavorite, toggleFavorite } = useFavorites(property.id);



  const [isShare, setIsShare] = useState(false);
  const handleShareClick = () => {
    setIsShare(!isShare);
  };

  const [showContactModal, setShowContactModal] = useState(false);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  const [showRequestTourModal, setShowRequestTourModal] = useState(false);
  const [showConfirmTourModal, setShowConfirmTourModal] = useState(false);
  const [tourData, setTourData] = useState(null);
  const handleShowRequestTour = () => setShowRequestTourModal(true);
  const handleCloseRequestTour = () => setShowRequestTourModal(false);
  const handleShowConfirmTour = () => setShowConfirmTourModal(true);
  const handleCloseConfirmTour = () => setShowConfirmTourModal(false);
  const handleNextFromRequestTour = (data) => {
    setTourData(data);
    setShowRequestTourModal(false);
    setShowConfirmTourModal(true);
  };
  const handleNextFromRequestTourTwo = () => {
    setShowContactModal(false);
    handleShowRequestTour(true);
  };
  const handleOldClose = () => {
    handleClose();
  }

const imageCategoryMap = React.useMemo(() => {
  return property.all_images.reduce((acc, img) => {
    if (!img.image_type || img.image_type === "General") return acc;

    acc[img.image_type] = (acc[img.image_type] || 0) + 1;
    return acc;
  }, {});
}, [property.all_images]);


  const imageCategories = React.useMemo(() => {
  const categories = Object.keys(imageCategoryMap);

  //Only ALL PHOTOS
  if (categories.length === 0) {
    return ["All Photos"];
  }

  return ["All Photos", ...categories];
}, [imageCategoryMap]);


  const tabKey = (label = "") =>
    String(label).toLowerCase().replace(/\s|\//g, "-");

  const renderGallery = (images) => (
    <div className="tab-content-wrap">
      <Row className="gy-4">
        {images.map((img, index) => {
          const isFullWidth =
            index === 0 ||
            index === 3 ||
            index === 6 ||
            index % 3 === 0;

          return (
            <Col key={img.id} md={12} lg={isFullWidth ? 12 : 6}>
              <img
                src={img.image}
                alt={img.caption || img.image_type}
                className="img-fluid"
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );



  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        scrollable
        className="all-photo-modal modal-90w"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <div className="all-photo-header">
              <Nav variant="tabs" className="custom-tabs">
                <Nav.Item>
                  <Nav.Link
                    active={activeAllPhotoTab === "photos"}
                    onClick={() => setActiveAllPhotoTab("photos")}
                    className="d-flex align-items-center"
                  >
                    Photos
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={activeAllPhotoTab === "street-view"}
                    onClick={() => setActiveAllPhotoTab("street-view")}
                    className="d-flex align-items-center"
                  >
                    Street View
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <div className='button-group'>
                {activeAllPhotoTab === "street-view" && (
                  <>
                    <Button
                      className={`custom-bttn`}
                      onHide={handleClose}
                      onClick={(e) => { handleOldClose(); handleShowRequestTour(); }}
                    >
                      Request a Tour
                    </Button>
                    <Button
                      className={`custom-bttn style-3`}
                      onHide={handleClose}
                      onClick={() => navigate('/get-pre-qualified')}
                    >
                      Get Prequalified
                    </Button>
                  </>
                )}
                <Button
                  className={`custom-bttn fhs-button ${isFavorite ? "active" : ""}`}
                  onClick={toggleFavorite}
                >
                  <img src={FavoriteButton} alt="" /> Favorite
                </Button>
                <Button
                  className={`custom-bttn fhs-button ${isShare ? "active" : ""}`}
                  onClick={handleShareClick}
                >
                  <img src={ShareButton} alt="" /> Share
                </Button>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-off-gray">
          <Container>
            {activeAllPhotoTab === "photos" && (
              <div className="tab-content-wrap">
                <Row>
                  <Col md={12} lg={8} xl={9}>
                    <div className="photo-gallery">
                      <Nav variant="tabs" className="custom-tabs">
                        {imageCategories.map(category => {
                          const key = tabKey(category);

                          return (
                            <Nav.Item key={key}>
                              <Nav.Link
                                active={activePhotoGalleryTab === key}
                                onClick={() => setActivePhotoGalleryTab(key)}
                                className="d-flex align-items-center bg-transparent"
                              >
                                {category}
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                      </Nav>


                      {imageCategories.map(category => {
                        const key = tabKey(category);

                        if (activePhotoGalleryTab !== key) return null;

                        const images =
                          category === "All Photos"
                            ? property.all_images
                            : property.all_images.filter(
                              img => img.image_type === category
                            );

                        return <React.Fragment key={key}>{renderGallery(images)}</React.Fragment>;
                      })}

                    </div>
                  </Col>
                  <Col md={12} lg={4} xl={3}>
                    <div className="product-sidebar">
                      <Button className="custom-bttn w-100 mb-3" onClick={(e) => { handleOldClose();; handleShowRequestTour(); }}>
                        Request a Tour
                      </Button>
                      <p className="border-bottom">Tour  for free, no strings attached.</p>
                      <Button className="custom-bttn w-100 style-3  mb-3" onClick={(e) => { handleOldClose();; handleShowContactModal(); }}>
                        Contact an Agent
                      </Button>
                      <p>Make a winning offer with the help of a local agent.</p>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            {activeAllPhotoTab === "street-view" && (
              <div className="tab-content-wrap">
                <StreetView lat={property.latitude} lng={property.longitude} />
              </div>
            )}
          </Container>
        </Modal.Body>
      </Modal>
      <ContactAgentModal show={showContactModal} handleClose={handleCloseContactModal} />
      <RequestTourModal main_image={property.main_image} property_id={property.id} slots={property.slots} street_address={property.street_address}
        beds={property.details.bedrooms} baths={property.details.bathrooms} size={property.size_sqft}
        show={showRequestTourModal}
        handleClose={handleCloseRequestTour}
        onNext={handleNextFromRequestTour}
      />

      <ConfirmTourModal
        show={showConfirmTourModal}
        handleClose={handleCloseConfirmTour}
        tourData={tourData}
      />
    </>
  );
}

export default AllPhotoModal;